import { AIProjectClient } from "@azure/ai-projects";
import type { TokenCredential } from "@azure/identity";

export interface DiscoveredAgent {
  name: string;
  metadata: Record<string, string>;
}

// Wire shape of agent records yielded by project.agents.list().
// The SDK's Agent type doesn't expose metadata — the actual REST payload does.
// Mirrors the pattern in plugins/m8t/server/src/foundry-client.ts.
interface RawAgent {
  id?: string;
  name?: string;
  metadata?: Record<string, string>;
  versions?: {
    latest?: {
      metadata?: Record<string, string>;
    };
  };
}

/** project.agents.list() filtered to metadata.source === "m8t". */
export async function listM8tAgents(args: {
  credential: TokenCredential;
  projectEndpoint: string;
}): Promise<DiscoveredAgent[]> {
  const project = new AIProjectClient(args.projectEndpoint, args.credential);
  // Cast to the raw wire shape — the SDK types don't expose metadata at the
  // top-level Agent, but the REST payload carries it there.
  const iter = (project as unknown as {
    agents: { list: () => AsyncIterable<RawAgent> };
  }).agents.list();
  const result: DiscoveredAgent[] = [];
  for await (const raw of iter) {
    if (!raw.name && !raw.id) continue;
    const name = String(raw.name ?? raw.id);
    const md = raw.metadata ?? raw.versions?.latest?.metadata ?? {};
    if (md.source === "m8t") {
      result.push({ name, metadata: md });
    }
  }
  return result;
}
